import React, { Component, Fragment } from 'react';
import { gerenciarUsuariosLocaisGenerateNewPassword, gerenciarUsuariosLocaisSave } from '../../graphql/UsuarioLocal';
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Query, withApollo, Mutation } from "react-apollo";
import { gerenciarUsuariosLocaisListQuery, gerenciarUsuariosLocaisArquivarMutation, gerenciarUsuariosLocaisRestaurarMutation } from '../../graphql/UsuarioLocal';
import autoBind from 'react-autobind';
import { Button, Row, Col, ButtonToolbar, Form } from 'react-bootstrap';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import RemoveRedEyeOutlinedIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import UndoOutlinedIcon from '@material-ui/icons/UndoOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import UsuarioLocalWidgetForm from '../../widgets/definicoes/usuario-local/UsuarioLocalWidgetForm';
import MaterialTableUtils from '../../environment/materialTableUtils';
import Environment from "../../environment/environment";
import Swal from 'sweetalert2';

const { Group } = Form;

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
});

class AdmUsuarioLocal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            verArquivados: false,
            showModal: false,
            id: null
        }

        autoBind(this);
    }

    handlePasswordGeneration(data) {
        this.props.client.mutate({
            mutation: gerenciarUsuariosLocaisGenerateNewPassword,
            variables: { id: data.id },
          }).then(() => Swal.fire({
            title: "Nova senha",
            text: "Nova senha enviada com sucesso",
            icon: "success",
            confirmButtonColor: "#5d5d5d",
            showCancelButton: false,
        })).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
             Swal.fire({
                title: "Não foi possível enviar a nova senha",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });
    }

    handleShowModal(id, action) {
        this.setState({
            showModal: true,
            id: id || null,
            action
        });
    }

    handleModalClose() {
        this.setState({
            showModal: false,
            id: null
        });

        this.doRefetch();
    }

    doRefetch() {
        if (!this._queryRefetch)
            return;

        this.props.client.clearStore().then (
            () => this._queryRefetch(this._queryVariables ? { variables: this._queryVariables } : {})
        ) ;
    }

    render() {
        const {  id, showModal } = this.state;
        const { classes } = this.props;

        return (
            <Paper className={classes.root}>
                {this.renderBreadCrumb()}

                <Row>
                    <Col>
                        { this.renderBotoesSuperiores() }
                    </Col>

                </Row>

                {
                    <Fragment>
                        {this.renderGridPrincipal()}
                    </Fragment>
                }
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showModal}
                    onClose={this.handleClose}
                >
                    <div className={classes.paper}>
                        <Paper className={classes.root}>
                            <UsuarioLocalWidgetForm id={id} action={this.state.action} handleModalClose={this.handleModalClose} />
                        </Paper>
                    </div>
                </Modal>
            </Paper >
        );
    }

    renderGridPrincipal() {
        this._queryVariables = {
            arquivado: this.state.verArquivados
        };

        const actions = this.geraActions();

        return (
            <Query query={gerenciarUsuariosLocaisListQuery} variables={{ ...this._queryVariables }} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error! ${error.message}`
                    this._queryRefetch = refetch;

                    return (
                        <MaterialTable
                            actions={actions}
                            columns={[
                                {   title: "Nome",
                                    field: "nome",
                                    defaultSort: "asc",
                                    customSort: MaterialTableUtils.getInsensitiveSortFunctionByAttribute('nome') },
                                {   title: "Email", field: "email" },
                                {   title: "Grupo", field: "grupo_local.nome" },
                                {   title: "Instituição", field: "instituicao" },
                                {   title: "Cargo", field: "cargo" },
                                {   title: "Data Inicio Validade", field: "data_inicio_validade", render: data => Environment.momentToLocalDateString(data.data_inicio_validade) },
                                {   title: "Data Fim Validade", field: "data_fim_validade", render: data => Environment.momentToLocalDateString(data.data_fim_validade) }
                            ]}
                            data={data.usuariosLocaisList}
                            localization={{
                                body: {
                                    emptyDataSourceMessage: 'Nenhum usuário local encontrada'
                                },
                                header: {
                                    actions: 'Ações'
                                },
                                toolbar: {
                                    searchPlaceholder: 'Pesquisar',
                                    searchTooltip: 'Pesquisar'
                                }
                            }}
                            options={{
                                actionsColumnIndex: -1,
                                paging: false,
                                draggable: false,
                                sorting: true
                            }}
                            title={
                                this.state.verArquivados ? "Usuários Locais (arquivados)" : "Usuários Locais"
                            }
                        />
                    );
                }}
            </Query>
        );
    }

    geraActions() {
        const actions = [];
        const somenteLeitura = false;

        actions.push({
            icon: LockOutlinedIcon,
            tooltip: 'Gerar nova senha',
            onClick: (event, rowData) => this.handlePasswordGeneration(rowData),
        });

        // Botão de arquivar ou restaurar
        if (this.state.verArquivados) {
            actions.push({
                hidden: somenteLeitura,
                icon: UndoOutlinedIcon,
                tooltip: 'Restaurar',
                onClick: (event, rowData) => {
                    this.props.client.mutate({
                        mutation: gerenciarUsuariosLocaisRestaurarMutation,
                        variables: {
                            id: rowData.id
                        }
                    })
                    .then(() => this.doRefetch())
                    .catch( error => {
                        const errorMessage = error.graphQLErrors.map ( e => e.debugMessage).join("\n");
                        Swal.fire({
                          title: "Erro ao salvar usuário local",
                          text: errorMessage || "",
                          icon: "error",
                          confirmButtonColor: "#ff0000",
                          showCancelButton: false,
                        });
                    });
                }
            });
        } else {
            actions.push({
                hidden: somenteLeitura,
                icon: DeleteOutlinedIcon,
                tooltip: 'Arquivar',
                onClick: (event, rowData) => {
                    this.props.client.mutate({
                        mutation: gerenciarUsuariosLocaisArquivarMutation,
                        variables: {
                            id: rowData.id
                        }
                    }).then(() => this.doRefetch());
                }
            });

            actions.push({
                hidden: somenteLeitura,
                icon: EditOutlinedIcon,
                tooltip: 'Editar',
                onClick: (event, rowData) => this.handleShowModal(rowData.id, 'edit')
            });

            actions.push({
                icon: RemoveRedEyeOutlinedIcon,
                tooltip: 'Ver',
                onClick: (event, rowData) => this.handleShowModal(rowData.id, 'view')
            });

            
        }

        return actions;
    }

    renderBotoesSuperiores() {
        const { classes } = this.props;
        return (
            <Group className="btn-bar">
                <ButtonToolbar>
                    <Button disabled={false} variant="primary" className={`${classes.button} btn-primary-get`} onClick={() => this.handleShowModal(null, 'new')}>
                        Novo Usuário
                    </Button>
                    {
                        this.state.verArquivados !== true
                            ? (
                                <Button variant="secondary" className={`${classes.button} btn-secondary-get`} onClick={() => this.setState({ verArquivados: true })} >
                                    Lixeira
                                </Button>
                            ) : (
                                <Button variant="secondary" className={`${classes.button} btn-secondary-get`} onClick={() => this.setState({ verArquivados: false })} >
                                    Sair da lixeira
                                </Button>
                            )
                    }
                </ButtonToolbar>
            </Group>
        );
    }


    renderBreadCrumb() {
        // const {  } = this.props;
        return (
            <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                <Typography >Administrar</Typography>
                <div>Usuário Local</div>
            </Breadcrumbs>
        );
    }
}

export default (withStyles(styles)(withApollo(AdmUsuarioLocal)));